import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: {
      breadcrumb: {
        UnitsList: "Units List",
        prospectslist : "Prospects List",

        EditProspect: "Edit Prospect",
        addProspect: "Add Prospect",
        AddUser: "Add User",
        AddBuilding: "Add a Building",
        AddBuildingForUser: "Add a building",
        EditBuildingForUser: "Edit a building",

        UserList : "Users List",
        BuildingList : "Building List",
        UnitRented : "Rented Units",
        Budgets : "Budget",
        EditReference : "Edit References",
        EditCreditCondition : "Edit Credit Conditions",
        EditUserForBuilding: "Edit User",
        AddUserForBuilding: "Add User",
        TaskAssignment: "Task Assignment",
        groupManagement: "Group management",
        Reports: "Reports",
        AchalandageReport: "Traffic report",
        VacancyReport: "Vacancy report",
        LeadsReport: "Leads report",
        UnitsRentedReport: "Units Rented Report",
        DrApprobation: "Applications List",
        ApplicationsList: "Applications List",
        PastApplicationsList: "Past Applications List",
        Treatment: "Treatment",
        CreditReporting: "Daily report",
        UploadApplicationForm: "Add an application",
        Leads: "Leads",
        addVisit: "Add a visit",
        BuildingServices: "Inclusions",
        TotalVacanciesReport: "Total Vacancies Report"
      },
      title: {  
        groupAssignment: "Group assignment",
        plannerGroupingList: "Grouping List",
        report: "Report",
        taskTable: "Task table", 
        cleanup: "Cleanup management",
        automaticReply: "Automatic reply",
        keyClientManagement: "Key client management",
        TaskDispatcher: "Current Task Table",
        dashboard: "Dashboard",
        taskAssignment: "Task assignment",
        groupManagement: "Group management",
        taskManagement: "Task management",
        GroupBuildingCreation : "With the building team",
        GroupUserCreation : "With crm user",
        groupCreation : "Create a new group",
        groupEdit : "Edit existing groups",
        inclusions: "Inclusions",
        Leads: "Leads",
        endorsers: "Endorser(s)",
        applicants: "Applicant(s)",
        treatmentDataSheet: "Treatment Data Sheet for applications",
        interestByRoomSize: "Interest by unit type",
        prospectReference: "Origin",
        drApprobation: "Approbation request",
        achalandage: "Traffic",
        vacants: "Vacancy",
        visit: "Visit",
        creditInfo: "Credit Info",
        reports: "Reports",
        UploadBudgetCsv: "Upload budget (.csv) for a year",
        EditUserBuilding: "Edit a user building",
        EditUserForBuilding: "Edit the users of a building",
        budgetManagement: "Budget Management",
        userManagement: "User Management",
        buildingManagement: "Building Management",
        replaceApplication: "Replace documents",
        rentRequest: "Tenant form",
        Id: "Identification",
        proof: "Proof of income",
        applicantType: "Applicant type",
        otherDoc: "Other documents",
        bondform: "Bond form",
        user: "User",
        prospect: "Add a prospect",
        EditProspect: "Update a prospect",
        AddUser: "Add a user",
        EditUser: "Update a user",
        menu: "Menu",
        unitstable: "List of units by property",
        unitslist: "Units List",
        usersList: "Users",
        app: "Prospect Tracking",
        success: "Success",
        prospectslist:"Prospects List",
        list0: "Vacant with no income",
        list1: "Departure | Departures",
        unitsfor: "List of units for ",
        lang: "Language",
        statusform: "Status form",
        footer: "Footer",
        selectedunits: "Selected unit | Selected units",
        selectedunitsFor: "New unit",
        originalSelectedunits: "Actual building or unit for {0}",
        linkUnitProspect: "Link unit to prospect",
        confirmation: "Confirmation",
        followup: "Follow-up",
        stats: "Statistics",
        followupType: "Follow-up type",
        comType: "Communication type",
        hours: "hour",
        reference: "Reference",
        copyright: "Société de gestion Cogir, all right reserved.",
        vacant1st: "Vacant on the first of the month",
        departuresEndofMonth: "+ Departures at the end of the month",
        newLocation: "- New Lease",
        finalVacancies: "Final Vacancies",
        charts: "Charts",
        applicationStatus: "Application Status",
        applicationsList: "Applications List",
        pastApplicationsList: "Past Applications List",
        followUpList: "Follow Up List",
        notificationStatus: "Notification status",
        /**/
      },
      label: {  
        userType: "User type",
        user: "User",
        owner: "Owner",
        first: "first",
        second: "second",
        third: "third",
        fourth: "fourth",
        last: "last",
        sunday: "sunday",
        monday: "monday",
        tuesday: "tuesday",
        wednesday: "wednesday",
        thursday: "thursday",
        friday: "friday",
        saturday: "saturday",
        filterBy: "Select filter",
        numberOfGroupSelect: "Number of groups selected",
        numberOfTaskNotFound: "Number of tasks not found",
        taskTable: "Task table",
        cleanupType: "Cleanup type",
        newBuilding: "New building",
        pushCategory: "Push categories for all groups",
        completedBy: "Completed by",
        noMemberChoose: "No member selected",
        assignment: "Assignments",
        noAssociation: "No association",
        details: "Details",
        value: "Value",
        taskThumbnail: "Task thumbnail",
        bucketList: "Bucket list",
        labelList: "Label list",
        taskName: "Task name",
        taskByBuilding: "Task by building",
        taskEventList:  "See the buildings associated with a task",
        selectTask: "Select a task",
        label: "Label",
        priorityLevel: "Priority level",
        category: "Category",
        groupType: "Group type",
        removeTask: "Remove task",
        removeGroup: "Remove task",
        task: "Task",
        taskList: "Task list",
        taskTitle: "Task title",
        fieldList: "Field list",
        groupList: "Group list",
        buildingName: "Building name",
        teamName: "Team name",
        createdDateTime: "Creation",
        dueDateTime: "Due datetime",
        completedDateTime: "Completed",
        title: "Title",
        existingGroup: "Associated group",
        noExistingGroup: "No associated group",
        currentGroup: "Current group",
        newGroup: "New group",
        nameOfTheGroup: "Group name",
        associateToGroup: "Associate the building with an existing group",
        createNewGroup: "Create a new group for this building",
        associateUserToGroup: "Associate one or more user with an existing group",
        createNewUserGroup: "Choose user(s) to create a new group",
        totalVacancies: "Total vacancies",
        needValidation: "To Validate",//"Need approbation",
        infoUpload: "Upload information",
        unitFor: "For the unit ",
        unitPriceUnder: "the displayed price is below the market value : ",
        unitPriceOver: "the displayed price is above the market value : ",
        unitPriceEqual: "the displayed price is equal to the market value : ",
        publicWebsite: "Public website",
        detail: "Details",
        contactInformation: "Contact information",
        contactDate: "Contact Date",
        sortBy: "Sort by",
        unitFilter: "Unit",
        bedroomFilter: "Bedroom",
        sortOrder: "Sort order",
        StatusLeads: "Status",
        OptinLeads: "Consent",
        from: "From",
        availabilityDate: "Availability date",
        newStatus: "New status",
        add: "Add",
        consent: "Consent",
        addApplicant: "Add applicant",
        removeApplicant: "Remove",
        dailyReport: "Daily report",
        prospectUser: "Entered By",
        TYPLOG: "Unit Type",
        noComments: "No comments",
        folderTreated: "Dossier treated by <strong>{0}</strong>",
        folderTreatedSimple: "Dossier treated by {0}",
        buildingCote: "Rating for the building",
        COTE: "Cote",
        COLLECTION: "Collection",
        bankcrupcy: "Bankruptcy",
        badPayer: "Bad payer",
        regie: "Régie du logement",
        salary: "Declared salary",
        leaseStart: "Lease period (12 months) Beginner",
        leaseEnd: "End of lease period",
        leaseAmount: "A lease in the Amount of",
        leaseType: "Lease type",
        cession: "Lease assignment",
        transfert: "Lease transfer",
        address: "Address",
        apartment: "Apartment",
        treatment: "Treatment",
        treatmentReport: "Treatment report for {0}",
        yes: "Yes",
        no: "No",
        occupancyReport: "Occupancy Report",
        lastUpdate: "Last Update : ",
        tableOccupancyTitle : ["", "Nb Total doors", "Average rent", "Total sq ft.", "Vacants Units", "Vacancy Sq. Ft.", 
        "Vacancy Door", "Vacancy Sq Ft.", "Total Occupancy Door", "Total Occupancy Sq. Ft"],
        leadsReport: ['Fullname', 'Email', 'Consent', 'Status', 'Creation' ,'Source', 'Communication', 'Reference'],
        unitsRentedTitles: ['Fullname', 'Prospect Creation', 'Building', 'Unit', 'Rental date', 'Rental Creation Date'],
        unitsRentedFormHopem: ['First Name', 'Last Name', 'Building', 'Unit', 'Rental date', 'Assignment of lease'],
        unitsRentedFormDb: ['Building', 'Number of leases signed during the period'],
        totalVacanciesFormDb: ['Building', 'Number of vacant on the first of the month'],
        labelStatus: ['','Not processed', 'Removed', 'Prospect'],
        labelConsent: ['No', 'Yes'],
        tableAchalandageReport: ['Name', 'Building', 'Unit', 'Rooms' ,'First Name', 'Last Name', 'Tel', 'Email', 'Lg', 'Gender',
        'Prospect creation', 'Status', 'Origin','Visit', 'Lease', 'Reason', 'Duration'],
        currentVacantsUnit : "Current vacant units",
        departures: "departures",
        tableSubTitle: ['Unit', 'Type', 'Sqft', 'Status'],

        totalOccupancyDoors: "Total Occupancy per unit type %",
        downloadCsvTemplate: "Download template",
        list: "List",
        to: " to ",
        show: "Show",
        noshow: "No show",
        visitToCome: "coming visit",
        visitPast: "this visit took place",
        visitStatus: "Visit Status",
        cote: "Credit rating",
        prospectRemoved: "Removed",
        reportType: "Report type",
        edit: "Edit",
        year: "Year",
        downloadZip: "Download Zip file",
        locationDate: "Rental Date",
        reason: "Reason",
        comments: "Comments",
        notificationCenter: "Notification Center",
        unitRented: "Rented units",
        emptyUnitRented: "No units rented",
        emptyUser: "No user",
        empty: "No data",
        emptyMessage: "Empty message",
        actualUnit: "Actual Unit",
        noUnit: "No unit available",
        days: "days",
        eventname: "Event name",
        report: "Report",
        genders: {"m": "Man", "w": "Woman", "o": "Other"},
        next: ["Communication", "Visit", "Application", "Rental", "Rented" ],
        next1: ["Schedule a visit", "Waiting for a visit", "Submit an application", "Unit is rented" ],
        fullname: "Full name",
        fname: "First name",
        firstcontact: "First Contact",
        lname: "Last name",
        email: "Email",
        all: "All",
        allUnitRented: "Signatures",
        allBuilding: "All building",
        tel: "Phone",
        date: "Creation",
        gender: "Gender",
        language: "Language",
        properties: "Properties",
        property: "Property",
        man: "Man",
        woman: "Woman",
        other: "Other",
        languages: {"fr" : "French", "en" : "English"},
        french: "French",
        english: "English",
        type: "Contact type",
        calendar: "Calendar",
        credit: "Credit",
        locationcontract: "Rental contract",
        facetoface: "In person",
        emailtype: "By email",
        phonetype: "By phone",
        tablesize: "Number of entries in the table : ",
        building:"Building",
        unit: "Unit",
        dateFrom: "Date from",
        dateTo: "Date to",
        unitlabel:"Unit | Units",
        otherunit: "Other unit | Other units",
        nootherunit: "No other unit",
        nbpieceslabel: "Rooms",
        dateexplabel: "Exp",
        datedeplabel: "Dep",

        applicationLabel: "Application",
        rentedLabel: "Rented",

        status: "Status",
        statusType: "Status type",
        nbrunit: "Total # of units",
        nbrvacant: "Vacant unit(s)",
        renttotal: "Rented total",
        percentage: "Percentage",
        vacantdepuis: "Vacant since",
        vacantfutur: "Will be vacant",
        codeocc: "Occ",
        datedep: "Departure",
        signed: "Signed lease",
        application: "Application",
        notready: "Not ready",
        ready: "Ready",
        unitinfo: "Unit information",
        locationinfo: "Rental Information",
        prospectinfo: "Prospect Information",
        noprospect: "No prospect",
        prospect: "Prospect",
        //UnitPanel
        floor: "Floor(s)",
        surface: "Surface",
        orientation: "Orientation",
        market: "Value",
        loyact: "Current rent",
        loyevent: "Possible rent",
        expdate: "Expiration date",
        calendarinvite: "Send a visit request",
        visit: "Unit visit",
        rented: "Unit rented",
        step: "Next step",

        //MeetingRequest
        startDate: "Start date",
        startTime: "Start time",
        endTime: "End Time",
        endDate: "End date",
        start: "Start",
        end: "End",
        eventDate: "Event date",
        duration: "Duration",
        subject: "Subject",
        description: "Description",
        nodescription: "Empty",
        location: "Location",
        organizer: "Organizer",
        emailattendees: "Participants",
        meetingType: "Meeting Type",
        virtualMeeting: "Virtual visit with Microsoft Team",
        inplaceMeeting: "On site visit",

        //application status
        approve: "Approve",
        approved: "Approved",
        approvedByDirection: "Approved by the management",
        waitingEndorsement: "Waiting Endorsement",
        waitingDocument: "Waiting Document",
        waitingCredit: "Waiting Credit",
        refused: "Refused",
        newApplication: "New application",
        documentReceive: "Document received by endorser",
        missingDocReceive: "Missing documents received",
        visitSchedule: "Schedule a visit",
        waitingVisit: "Waiting for a visit",
        applicationToSubmit: "Submit an application",
        needEndorser: "Need an endorser",
        needEndorsers: "Need one or more endorser(s)",

        Doc1: "Form",
        Doc2: "Identification",
        Doc3: "Proof of income",
        otherDoc: "Other documents",
        awaitingFile: "Awaiting missing file(s)",
        Missing: "Missing",
        docType: "File type",
        visitInfo: "Visit info",
        
        //event name
        newProspect: "New Prospect",        
        visitAfter: "Visit completed",
        rentedReady: "Ready to rent",
        unitNotAvailable: "Unit not available",
        replaceUnit: "Assign unit",
        rentalDate: "Rental date",
        price: "Price",
        /* From public website */
        fiche : {
          /* building */
          step1Title: "Rental form",
          title: "Rental request",
          IdImmeuble : "Identification of the building",
          nomImeuble: "Building Name",
          adresseImmeuble: "Building Address",
          appartement: "Apartment",
          loyer: "Lease",
          period: "Period",
          from: "From",
          to: "To",
          rooms: "Rooms",
          inclusions: "Inclusions",
          otherServices: "Other Services",
          promotions: "Promotions",
          /*candidat*/
          Idprospect: "Identification of the candidate",
          fname: "First name",
          lname: "Last name",
          email: "Email",
          cell: "Cell",
          phone: "Phone",
          birthdate: "Birthdate",
          chooseAddress: "Find your address",
          addressCandidate: "Current address",
          civic: "Civic number",
          street: "Street",
          locality: "City",
          app: "App #",
          province: "Province",
          country: "Country",
          postal: "Postal Code",
          civilStatus: [{value: null, text: "Civil Status"}, {value: 1, text: "Single"}, {value: 2, text: "Married"},
          {value: 3, text: "Common-law partner"}, {value: 4, text: "Widower"} , {value: 5, text: "Divorced"} , {value: 6, text: "Separate"} ],
          childPossession: "Child / Children",
          yes: "Yes",
          no: "No",
          age: "Age",
          experienceCogir: "Rental experience with Cogir",
          experienceQuestion : "Have you ever lived in a building managed by Cogir ?",
          buildingName: "Building Name",
          completeAddress: "Complete address",
          rentedMonth: "Rent / month",
          startDate: "Start date",
          endDate: "End date",
          contactName: "Name of Owner / Concierge",
          contactPhone: "Phone number",
          /*Job information */
          jobInformation: "Job information",
          currentSituations: [{value: null, text: "Current situation"}, {value: 1, text: "Employed"}, {value: 2, text: "Employment Insurance"},
          {value: 3, text: "Welfare"}, {value: 4, text: "CNESST"} , {value: 5, text: "Retirement income"} , {value: 6, text: "Other"} ],
          otherSituation: "Other situation",
          emplInsurance: "Employment Insurance",
          welfare: "Welfare",
          CNESST: "CNESST",
          retIncome: "Retirement income",
          otherIncome: "Other income",
          employerName: "Employer name/City",
          rhDirector: "R.H director",
          employerPhone: "Employer phone",
          position: "Position",
          annualSalary: "Annual salary",
          otherAmount: "Amount",
          totalIncome: "Total income",
          student: "Student",
          studentQuestion: "Are you a student ?",
          school: "School/University",
          pretBourse: "Loan/Scholarship",
          banque: "Bank",
          bankName: "Bank name",
          bankAddress: "Bank branch address",
          personalRef: "Personal references",
          refName: "Full name",
          refAddress: "Complete address",
          refCity: "City",
          refCell: "Cell",
          refPhone: "Phone",
          consent: "Consent",
          endorserForm: "Endorser form",
          endorserSignature: "Endorser signature",
          prp: "*** Please note that our Company is subject to and complies with the Personal Information Protection and Electronic Documents Act (LPRPSP).",
          declaration: "I, the undersigned, declare that all of the above information as truthful and hereby authorize any person (private investigative agent, credit officer, my employer and "+
          "current or past landlord) to divulge my personal information to the lessor, his representative or agent in order to evaluate the present rental proposal or for any "+
          "amendment, renewal or extension of my tenancy. It is clearly understood that all information given on this application or obtained by the landlord and / or his "+
          "representatives is confidential. Furthermore, I agree to sign the lease form provided if it is accepted within the next 10 days.",
          optIn: "By signing below, I hereby accept to receive any and all notices, correspondances, procedures or any and all other documents to be served or notified via my e-mail address."       
          }
      },
      action: {
        GroupMemberManagement: "Group member management",
        setRecurrence: "Repeat this task",
        dayOfWeek: "Day of week",
        specificDate: "Specific date",
        chooseFrequency: "Choose frequency",
        chooseWeekIndex: "Choose week index",
        chooseInterval: "Choose interval",
        viewTaskRecurrenceList: "View list",

        chooseGroupingName: "Choose a grouping name",
        managePlannerGrouping: "Add new grouping",
        editPlannerGrouping: "Edit grouping",
        followThatLink: "Follow that link",
        chooseReportType: "Choose report type",
        chooseFirstDate: "Choose the first date",
        chooseSecondDate: "Choose the second date",
        addBudgetBuildingData: "Add budget data for this building",
        removeAllData: "Remove all data",
        removeAnnualBudgetData: "Are you sure you want to remove budget data for this year ?",
        addBudgetDataForThisYear: "Add budget data for this year",
        getMemberOf: "View group members",
        removeKey: "Are you sure you want to remove this key ?",
        restoreKey: "Are you sure you want to restore this key ?",
        restore: "Restore",
        addFieldName: "Add a new field",
        addANewKey: "Add a new key",
        currentUserList: "Current assignation list",
        updateIndividualTask: "Update individual task",
        chooseGroup: "Choose a group",
        addAssociation: "Add association",
        chooseMemberOfTeam: "Choose a member of the team",
        chooseMembers: "Choose members",
        viewMembers: "View members",
        step1: "Choose a task",
        step2: "Assign a task",
        addUserTeamGroup: "Add user for a Team Group",
        removeUserTeamGroup: "Remove user from a Team Group",
        addNewTask: "Add a new task",
        selectAll: "Select all",
        selectAllBuilding: "Select all building groups",
        selectAllUser: "Select all user groups",
        assignTask: "Assign a task",
        resetTheList: "Reset the list",
        chooseUser: "Enter a user name",
        chooseBucket: "Choose a bucket",
        chooseLabel: "Choose a label",
        update: "Update",
        updateTaskEvent: "Update task for all buildings",
        removeTaskEvent: "Remove task for all buildings",
        useGenericEmail: "Click on this link to use the generic email (123@noemail.com)",
        clickLink: "Click on this link",
        addImage: "Add images",
        accepted: "Accepted",
        confirmedPrice: "Confirm unit price",
        SubmitUnitsCheck: "Submit {0} unit(s)",
        notinterested: "Not interested",
        confirmednewstatus: "Confirmed new status",
        receiptDate: "Date of receipt",
        decisionDate: "Date of decision",
        chooseStatus: "Choose status",
        drop: "Drop item to removed here",
        byDay: "By day",
        byMonth: "By month",
        byWeek: "By week",
        byYear: "By year",
        customRepeat: "Custom repeat",
        byrange: "By date range",
        newApplication : "New Application",
        cancelMeeting: "Cancel the event in the calendar",
        addRating: "Add",
        addCommunication: "Add a communication",
        addVisit: "Add a visit",
        addUnitVisit: "Add an unit for a visit",
        addApplication: "Add an application",
        generateReport: "Generate a report",
        generateExcel: "Generate an Excel report",
        validate: "Validate",
        addBuildingForUser: "Choose building",
        editBuildingForUser: "Edit building for user",
        removeAllActiveSession: "Remove all actives sessions",
        transfertAllSession: "Transfert all session to another user",
        gotoprospect: "Go to prospects list",
        login: "Sign in",
        logout: "Sign out",
        add: "Add",
        addUser: "Add a user",
        addYear: "Add a year",
        clearField: "Clear field",
        show: "Show",
        hide: "Hide",
        addProspect: "Add a prospect",
        chooseReason: "Choose a reason",
        choose: "Choose",
        chooseDate: "Choose a date",
        changeRentalDate: "Change rental date",
        chooseStartDate: "Choose a start date",
        chooseEndDate: "Choose an end date",
        chooseName: "Choose a name for display",
        comDate: "Communication date",
        selected: "Selected",
        report: "Get a report",
        search:"Search",
        searchprospects: "Search existing prospect",
        returntohomepage: "Return to home page",
        return  : "Return",
        returnToUM: "Return to user Management",
        submit: "Submit",
        copy: "Copy",
        addstatus: "Add a status",
        addevent: "Add an event",
        unitNotReady: "This unit is not ready",
        setUnitNotReady: "Set this unit not ready",
        unitReady: "This unit is ready",
        setUnitReady: "Set this unit ready",
        setUnitStatus : "Set unit status",
        addfollowup: "Add follow-up",
        choosefile: "Choose a file",
        suivi: "Follow up",
        infobuilding: "Unit information",
        change: "Change",
        confirmed: "To confirm",
        confirmedMr: "Check to confirm sending",
        rentedCheckbox: "The prospect <strong> {0} </strong> has rented the apartment {1}",
        edit: "Edit prospect",
        editUser: "Edit user",
        editBudget: "Edit budget",
        editBuilding: "Edit Building",
        addBuilding: "Add a building",
        addClient: "Add a client",
        addUnits: "Replace unit",
        delete: "Delete",
        remove: "Remove",
        rmve: "Are you sure you want to remove",
        cncl: "Cancel",
        send: "Send",
        prospectForUnit: "Go to prospects list for this unit",
        confirmedClosedEvent: "Unit ready to rented",
        teamMeeting: "Send a team meeting",
        applicationStatus: "Choose a new status",
        creditCondition: "Choose a condition",
        applicationDocType: "Choose a document type",
        missingDoc: "Add missing doc",
        endorser: "Add an endorser",
        changeStatus: "Status",
        credit: "Credit",
        cancelCurrent: "Cancel current request",
        confirmedCancellation: "Please click the button below to confirm",
        confirmedContact: "Click to confirm the sending of a communication",
        justwait: "Waiting for credit",
        historic: "History",
        history: "Application history",
        reset: "Reset field",
        editReference: "Edit references",
        editCreditCondition: "Edit conditions",
        reload: "Reload list",
        addNewRentalDate: "Add a new rental date"
      },
      info: {
        plannerGroupingMaxLength: "Group assignment is limited to 25 groups",
        plannerGroupMaxLength: "Task assignment is limited to 25 groups",
        noTaskForThisPeriod: "No task for this period",
        openTaskNoTFound: "The following open tasks were not found",
        taskNotFound: "The task was not found in the following groups :",
        inactiveKey: "This key is inactive. Please reactivate it in order to modify it.",
        groupSelectForTaskAssignment: "Group list",
        description: "Enter task information",
        chooseMultiple: "Use ctrl click to choose multiple items",
        taskPriority: [{ value: null, text: "Choose a level" }, { value: 9, text: "low" }, { value: 5, text: "medium" },  { value: 3, text: "important" }, { value: 1, text: "urgent" }],
        groupAlreadyExist: "This building is already associate to this group : ",
        taskOpen: "This task is open for a group",
        unauthorized: "You are not authorized to access this application",
        tooManyUser: "Too many user in the group. Max 20.",
        currentTeamMember: "Current team member",
        currentOwner: "Current owner",
        errorNoUserSelected: "You must select at least 2 users",
        choice: "Choices will appear here",
        buildingForUser: "Associate properties with a user",
        warningsamename: "A group with the same name exists for this building",
        errornoowner: "A new group must have at least one dr or admin and one user",
        existingTeamForBuilding: "This group is already associated with a building",
        excelFilesNotExist: "You must create a file {0} at the root of your Cogir Microsoft OneDrive account. https://cogirnet-my.sharepoint.com/",
        approbationRequest: "Choose whether the application is denied or approved for <strong>{0}</strong>.",
        publicProspectApplication: "Confirm that the application request for <strong>{0}</strong> is compliant.",
        requiredOne: "At least one file is required",
        acknowledgeNewUnit: "Confirm unit change",
        drApprobation: "Waiting for DR Approbation",
        successcanceled: "Visit successfully canceled",
        userAddedSuccess: "User added successfully",
        userRemovedSuccess: "User removed successfully",
        successnoshow: "Prospect status has been updated",
        showNoshow: "Prospect present or not for a visit",
        partOfDay: "Time of day when contact is made",
        meetingConflict: "There is already one or more events on your calendar for this time slot:",
        goAnyway: "Press submit to bypass this warning.",
        reportsLength: "No data for this request",
        meetingNotFound: "This visit was not found",
        meetingCancel: "This visit has been canceled",
        notCogirUser: "This email address is not part of the cogir.net domain",
        activesessions: "There are active sessions for this building",
        response: "Response Status",
        successgeneric: "Your information has been processed succesfully",
        successExcel: "Your information has been processed succesfully. Follow the link to get your Excel report.",
        successmeetingrequest: "Your meeting request has been send",
        nomeetingrequest: "An error occurred while sending the meeting request",
        emailexist: "This email belongs to an active prospect.",
        emailexistuser: "This email belongs to an active user.",
        months : 'January_February_March_April_May_June_July_August_September_October_November_December',
        required: "This field is required",
        email: "This email address is not valid",
        tel: "A phone number should only contain numbers",
        integer: "This must contain number",
        maxLength: "This field is limited to {0} characters",
        minLength: "This field must contain at least {0} characters",
        units: "You must choose at least one unit",
        errorfields: "All fields are required and must be numeric",
        errorgenericarg: "An error has occurred : {0}",
        errorgeneric: "An error has occurred",
        errorlogin: "Try to connect by pressing the login button.",
        errorfile: "Error in file upload",
        textConfirmed: "Press the button below to confirm that the prospect <br> <strong> {0} </strong> <br> has rented the apartment {1}",
        removeConfirmed: "Press the button below to confirm that the prospect <strong> {0} </strong> <br> is unlinked from the apartment {1}",
        removedTaskEvent: "Press the button below to confirm that the task <strong> {0} </strong> will be removed",
        removeConfirmedLeads: "Press the button below to confirm that the lead <strong> {0} </strong> is no longer active",
        removeConfirmedProspect: "Press the button below to confirm that the prospect <strong> {0} </strong> is no longer active",
        changeStatusProspect: "Press the button below to confirm that the prospect <strong> {0} </strong> is not interested",
        removeConfirmedUser: "Press the button below to confirm that the user <strong> {0} </strong> is no longer active",
        removeConfirmedUserBuilding: "Press the button below to confirm that the user <strong> {0} </strong> is no longer associate to the building <strong> {1} </strong>",
        removeFromUnitRented: "Press the button below to confirm that the prospect <strong> {0} </strong> is to be remove from the rented unit",
        removeBuilding: "Press the button below to confirm that the building <strong> {0} </strong> is no longer active",
        notoken: "Unable to acquire token",
        myMSALObj: "myMSALObj not valid",
        UserNotAuthorized: "User not authorized",
        MeetingRequestNotSend: "The meeting request was not send",
        startPast: "The start time is earlier than current time.",
        dateBefore: "The start date must be earlier than the end date.",
        maxVisitTime: "The maximum duration of a visit is 5 hours.",
        comments: "Comments ...",
        reason: "Add a reason",
        applicationStatus: "The new application status is : {0}",
        documentTypeError: "You must choose a document type for each field",
        updateMissingDoc: "You must provide {0} files",
        missingDocInProgress: "Missing Document(s). You are waiting for {0} file(s).",
        limitNumberOfFiles: "You cannot upload more than 3 files", 
        limitNumberOfFilesMissingDoc: "You cannot upload more files than the number of required documents",        
        invalidFileType: "File type not supported (.pdf, .jpg or .png) or file too large (max 4 mb)",
        requiredDoc: "File type supported (.pdf, .jpg or .png)",
        invalidFileSize: "File too large (max 4 mb)",
        invalidFileTypeCsv: "Invalid file type (csv)",
        invalidFileTypeFormat: "Invalid file format",
        startLocation : "Enter the rental start date",
        confirmationLocation: "Confirm rental date",
        emptyApplication : "No application at this time",
        emptyProspect: "No prospect for this building",
        emptyVacant: "No unit for this building",
        emptyNotification: "No notification at this time",
        emptyField: "All fields must be completed",
        infoevent: "Set a unit ready or not ready for rental",
        buildingExist: "This building is already register in the database",
        nobuilding: "There is no building with this NOCIE and NODIV",
        noendorserpossible : "All applicants have an endorser for this application",
        invalidDate: "You must choose a valid month",
        chooseAtLeastOneMember: "You must choose at least one member",
      },
    },
    fr: {
      breadcrumb: {
        UnitsList: "Tableau des unités",
        prospectslist : "Tableau des prospects",

        EditProspect: "Modification d'un prospect",
        addProspect: "Ajout d'un prospect",
        AddUser: "Ajout d'un utilisateur",
        AddBuilding: "Ajout d'une propriété",
        AddBuildingForUser: "Ajout d'une propriété",
        EditBuildingForUser: "Modification d'une propriété",
        TaskAssignment: "Assignation de tâches",
        groupManagement: "Gestion des groupes",

        UserList : "Gestion des utilisateurs",
        BuildingList : "Gestion des propriétés",
        UnitRented : "Gestion des unités louées",
        Budgets : "Gestion du budget",
        EditReference : "Références",
        EditCreditCondition : "Conditions",
        EditUserForBuilding: "Modification d'un utilisateur",
        AddUserForBuilding: "Ajouter un utilisateur",

        Reports: "Rapports",
        AchalandageReport: "Rapport d'achalandage",
        VacancyReport: "Rapport de vacants",
        LeadsReport: "Rapport des leads",
        UnitsRentedReport: "Rapport des locations",
        DrApprobation: "Liste des applications",
        ApplicationsList: "Liste des applications",
        PastApplicationsList: "Liste des applications passées",
        Treatment: "Fiche",
        CreditReporting: "Rapport journalier",
        UploadApplicationForm: "Ajouter une application",
        Leads: "Leads",
        addVisit: "Ajouter une visite",
        BuildingServices: "Inclusions",
        TotalVacanciesReport: "Rapport des vacants totaux"
      },
      title: {
        groupAssignment: "Assignation de groupe",
        plannerGroupingList: "Regroupements",
        report: "Rapport",
        taskTable: "Tableau des tâches",
        cleanup: "Nettoyage",
        automaticReply: "Rappel automatique",
        keyClientManagement: "Gestion des clients",
        TaskDispatcher: "Tableau des tâches courantes",
        dashboard: "Admin",
        taskAssignment: "Attribution de tâches",
        groupManagement : "Gestion des groupes",
        taskManagement : "Gestion des tâches",
        groupCreation : "Création d'un nouveau groupe",
        groupEdit : "Modification des groupes existants",
        GroupBuildingCreation : "Avec l'équipe d'un immeuble",
        GroupUserCreation : "Avec des utilisateurs du Crm",
        inclusions: "Inclusions",
        Leads: "Leads",
        endorsers: "Endosseurs(s)",
        applicants: "Applicant(s)",
        treatmentDataSheet: "Fiche de traitement pour les applications",
        prospectReference: "Provenance",
        interestByRoomSize: "Nb de pièce recherché",
        drApprobation: "Demande d'approbation",
        achalandage: "Achalandage",
        vacants: "Vacants",
        visit: "Visite",
        creditInfo: "Info crédit",
        reports: "Rapports",
        UploadBudgetCsv: "Téléverser le budget (.csv) pour une année",
        EditUserBuilding: "Modifier les propriétés d'un utilisateur",
        EditUserForBuilding: "Modifier les utilisateurs d'une propriété",
        budgetManagement: "Gestion des budgets",
        userManagement: "Gestion des utilisateurs",
        buildingManagement: "Gestion des propriétés",
        replaceApplication: "Remplacer les documents",
        rentRequest: "Formulaire du locataire",
        Id: "Pièce d'identité",
        proof: "Preuve de revenu",
        bondform: "Formulaire de cautionnement",
        otherDoc: "Autre document",
        applicantType: "Type de demandeur",
        user: "Utilisateur",
        prospect: "Ajouter un prospect",
        EditProspect: "Modifier un prospect",
        AddUser: "Ajouter un utilisateur",
        EditUser: "Modifier un utilisateur",
        menu: "Menu",
        unitstable: "Liste des unités par propriété",
        unitslist: "Liste des unités",
        usersList: "Utilisateurs",
        app: "Suivi des candidats",
        success: "Succès",
        prospectslist:"Liste des candidats",
        list0: "Vacants sans revenu",
        list1: "Départ | Départs",
        unitsfor: "Liste des unités pour ",
        lang: "Langue",
        statusform: "Formulaire ajout d'un statut",
        footer: "Pied de page",
        selectedunits: "Unité choisie | Unités choisies",
        selectedunitsFor: "Nouvelle unité choisie",
        originalSelectedunits: "Unité ou immeuble actuel pour {0}",
        linkUnitProspect: "Associer unité à un prospect",
        confirmation: "Confirmation",
        followup: "Suivi",
        stats: "Statistiques",
        followupType: "Type de suivi",
        comType: "Type de communication",
        hours: "heure",
        reference: "Référence",
        copyright: "Société de gestion Cogir, tous droits réservés.",
        vacant1st: "Vacants 1er du mois",
        departuresEndofMonth: "+ Départs à la fin du mois",
        newLocation: "- Nouvelle location",
        finalVacancies: "Vacants finaux",
        charts: "Diagrammes",
        applicationStatus: "Statut Application",
        applicationsList: "Liste des applications",
        pastApplicationsList: "Liste des applications passées",
        followUpList: "Liste des suivis",
        notificationStatus: "Statut des notifications"
        /**/
      },
      label: {
        userType: "Type d'utilisateur",
        user: "Utilisateur",
        owner: "Propriétaire",
        first: "Premier",
        second: "Deuxième",
        third: "Troisième",
        fourth: "Quatrième",
        last: "Dernier",
        sunday: "Dimanche",
        monday: "Lundi",
        tuesday: "Mardi",
        wednesday: "Mercredi",
        thursday: "Jeudi",
        friday: "Vendredi",
        saturday: "Samedi",
        filterBy: "Filtrer la liste",
        numberOfGroupSelect: "Nombre de groupes sélectionnés",
        numberOfTaskNotFound: "Nombre de tâches non trouvées",
        cleanupType: "Type de nettoyage",
        newBuilding: "Nouvelle propriété",
        pushCategory: "Pousser les catégories pour tous les groupes",
        completedBy: "Compléter par",
        noMemberChoose: "Aucun membre choisi",
        assignment: "Assignations",
        noAssociation: "Aucune association",
        details: "Détails",
        value: "Valeur",
        taskThumbnail: "Image de la tâche",
        bucketList: "Liste des buckets",
        labelList: "Liste des étiquettes",
        taskName: "Nom de la tâche",
        taskByBuilding: "Tâches associées à un immeuble",
        taskEventList: "Voir les immeubles associés à une tâche",
        selectTask: "Choisir une tâche",
        label: "Étiquette",
        priorityLevel: "Niveau de priorité",
        category: "Catégorie",
        groupType: "Type de groupe",
        removeTask: "Supprimer une tâche",
        removeGroup: "Supprimer un groupe",
        task: "Tâche",
        taskTitle: "Titre de la tâche",
        taskList: "Liste des tâches",
        fieldList: "Liste des champs",
        groupList: "Liste des groupes",
        buildingName: "Immeuble",
        teamName: "Groupe",
        createdDateTime: "Création",
        dueDateTime: "Date d'échéance",
        completedDateTime: "Compléter",
        title: "Titre",
        existingGroup: "Groupe associé",
        noExistingGroup: "Aucun groupe associée",
        currentGroup: "Groupe actuel",
        newGroup: "Nouveau groupe",
        nameOfTheGroup: "Nom du groupe",
        associateToGroup: "Associer l'immeuble à un groupe existant",
        createNewGroup: "Créer un nouveau groupe pour cet immeuble",
        associateUserToGroup: "Associer un ou plusieurs utilisateurs à un groupe existant",
        createNewUserGroup: "Choisir des utilisateurs pour créer un nouveau groupe",
        totalVacancies: "Total des vacants",
        needValidation: "À valider",
        infoUpload: "Information pour le téléversement",
        unitFor: "Pour l'unité ",
        unitPriceUnder: "le prix affiché est en dessous de la valeur du marché : ",
        unitPriceOver: "le prix affiché est au dessus de la valeur du marché : ",
        unitPriceEqual: "le prix affiché est égal à la valeur du marché : ",
        publicWebsite: "Site publique",
        detail: "Détails",
        contactInformation: "Coordonnées",
        contactDate: "Prise de contact",
        sortBy: "Ordonner par",
        unitFilter: "Unités",
        bedroomFilter: "Nombre de pièce",
        sortOrder: "Ordre de tri",
        StatusLeads: "Statut",
        OptinLeads: "Consentement",
        from: "À partir du",
        availabilityDate: "Date de disponibilité",
        newStatus: "Nouveau statut",
        add: "Ajouter",
        consent: "Consentement",
        addApplicant: "Ajouter un applicant",
        removeApplicant: "Enlever",
        dailyReport: "Rapport journalier",
        prospectUser: "Entré par",
        TYPLOG: "Type de logement",
        noComments: "Aucun commentaires",
        folderTreated: "Dossier traité par <strong>{0}</strong>",
        folderTreatedSimple: "Dossier traité par {0}",
        buildingCote: "Cote pour l'Immeuble",
        COTE: "Cote",
        COLLECTION: "Collection",
        bankcrupcy: "Faillite",
        badPayer: "Mauvais payeur",
        regie: "Régie du logement",
        salary: "Salaire déclaré",
        leaseStart: "Période du bail (12 mois) débutant",
        leaseEnd: "Fin de la période du bail",
        leaseAmount: "Un bail au montant de",
        leaseType: "Type de bail",
        cession: "Cession de bail",
        transfert: "Transfert de bail",
        apartment: "Appartement",
        address: "Adresse",
        treatment: "Fiche",
        treatmentReport: "Fiche de traitement pour {0}",
        yes: "Oui",
        no: "Non",
        occupancyReport: "Rapport d'occupation",
        lastUpdate: "Mise à jour : ",
        tableOccupancyTitle : ["", "Total unités", "Loyer moyen", "pi² total", "Unités vacantes", "Vacants pi²", 
        "Unités vacantes", "Vacants pi²", "Total Occupation", "Total Occupation pi²"],
        labelStatus: ['','Non traité', 'Prospect', 'Rejeté'],
        labelConsent: ['Non', 'Oui'],
        leadsReport: ['Nom complet', 'Courriel', 'Consentement', 'Statut', 'Creation' ,'Source', 'leadsReport', 'Communication', 'Reference'],
        unitsRentedTitles: ['Nom Complet', 'Création du prospect', 'Building', 'Unité', 'Date de location', 'Création de la location'],
        unitsRentedFormHopem: ['Prénom', 'Nom', 'Immeuble', 'Unité', 'Date de location', 'Cession de bail'],
        unitsRentedFormDb: ['Immeuble', 'Nombre de baux signés dans la période'],
        totalVacanciesFormDb: ['Immeuble', 'Nombre de vacant au début du mois'],
        tableAchalandageReport: ['Nom', 'Immeuble', 'Unité', 'Nb de pièce' ,'Prénom', 'Nom', 'Tel', 'Courriel', 'Lg', 'Genre',
        'Création', 'Statut', 'Provenance','Visite', 'Location', 'Raison', 'Durée'],
        currentVacantsUnit : "Unités vacantes",
        departures: "départs",
        tableSubTitle: ['Unité', 'Pièce', 'Pi²', 'Statut'],
        totalOccupancyDoors: "Taux d'occupation par nombre de pièce %",
        downloadCsvTemplate: "Télécharger le modèle",
        list: "Liste",
        to: " au ",
        show: "Présent",
        noshow: "Non présent",
        visitToCome: "Visite à venir",
        visitPast: "Cette visite a eu lieue",
        visitStatus: "Statut de la visite",
        cote: "Cote de crédit",
        prospectRemoved: "Enlever",
        reportType: "Type de rapport",
        edit: "Modifer",
        year: "Année",
        downloadZip: "Télécharger un fichier zip",
        locationDate: "Date de location",
        reason: "Raison",
        comments: "Commentaires",
        notificationCenter: "Centre de notification",
        noUnit: "Aucune unité",
        unitRented: "Unités louées",
        emptyUnitRented: "Aucune unité louée",
        emptyUser: "Aucun utilisateur",
        empty: "Aucunes données",
        emptyMessage: "Message vide",
        actualUnit: "Unité associée",
        days: "jours",
        eventname: "Nom de l'évènement",
        report: "Rapport",
        genders: {"m": "Homme", "w": "Femme", "o": "Autre"},
        next: ["Communication", "Visite", "Application", "Location", "Loué" ],
        next1: ["Planifier une visite", "En attende d'une visite", "Soumettre une application", "Loué" ],
        fullname: "Nom complet",
        firstcontact: "Première communication",
        fname: "Prénom",
        lname: "Nom",
        email: "Courriel",
        all: "Tous",
        allUnitRented: "Signatures",
        allBuilding: "Tous les immeubles",
        tel: "Téléphone",
        date: "Création",
        gender: "Genre",
        language: "Langue",
        properties: "Propriétés",
        property: "Propriété | Propriétés",
        man: "Homme",
        woman: "Femme",
        other: "Autre",
        languages: {"fr" : "Français", "en" : "Anglais"},
        french: "Français",
        english: "Anglais",

        type: "Type de contact",
        calendar: "Calendrier",
        credit: "Crédit",
        locationcontract: "Contrat de location",
        facetoface: "En personne",
        emailtype: "Par courriel",
        phonetype: "Par téléphone",
        tablesize: "Nombre d'entrées dans la liste : ",

        unitlabel:"Unité | Unités",
        otherunit: "Autre unité | Autres unités",
        nootherunit: "Aucun autre unité",
        building:"Immeuble",
        unit: "Unité",
        dateFrom: "Date de début",
        dateTo: "Date de fin",
        nbpieceslabel: "Pièces",
        dateexplabel: "Exp",
        datedeplabel: "Dep",

        applicationLabel: "Application",
        rentedLabel: "Loué",

        status: "Statut",
        statusType: "Type de statut",
        nbrunit: "Nombre de logement",
        nbrvacant: "Total vacant(s)",
        renttotal: "Total loué(s)",
        percentage: "Pourcentage",
        vacantdepuis: "Vacant depuis",
        vacantfutur: "Sera vacant",
        codeocc: "Occ",
        datedep: "Départ",
        signed: "Bail signé",
        application: "Application",
        notready: "Pas prêt",
        
        ready: "Disponible",
        unitinfo: "Information sur l'unité",
        locationinfo: "Information sur la location",
        prospectinfo: "Information sur le(s) candidat(s)",
        noprospect: "Aucun candidat",
        prospect: "Candidat",

        //UnitPanel
        floor: "Étage(s)",
        surface: "Superficie",
        orientation: "Orientation",
        market: "Valeur",
        loyact: "Loyer actuel",
        loyevent: "Loyer éventuel",
        expdate: "Date d'expiration",
        calendarinvite: "Envoyer une invitation pour une visite",
        visit: "Visite de l'unité",
        rented: "Unité loué",
        step: "Prochaine étape",

        //MeetingRequest
        startDate: "Date de début",
        startTime: "Heure de début",
        endTime: "Heure de fin",
        endDate: "Date de fin",
        start: "Début",
        end: "Fin",
        eventDate: "Date de l'évènement",
        endEvent: "Fin",
        duration: "Durée",
        subject: "Sujet",
        description: "Description",
        nodescription: "Vide",
        location: "Endroit",
        organizer: "Organisateur",
        emailattendees: "Invités",
        meetingType: "Type de visite",
        virtualMeeting: "Visite virtuelle avec Microsoft Team",
        inplaceMeeting: "Visite sur place",

        //application status

        approved: "Approuvé",
        approve: "Approuver",
        approvedByDirection: "Approuvé par la direction",
        waitingEndorsement: "Endosseur manquant",
        waitingDocument: "Document manquant",
        waitingCredit: "En attende du crédit",
        refused: "Refusé",
        
        newApplication: "Nouvelle Application",
        needEndorser: "Besoin d'un endosseur",
        needEndorsers: "Besoin d'un ou plusieurs endosseurs",
        documentReceive: "Documents reçus pour endosseur",
        missingDoc: "Documents manquants",
        missingDocReceive: "Documents manquants reçus",

        visitSchedule: "Planifier une visite",
        waitingVisit: "En attende d'une visite",
        applicationToSubmit: "Soumettre une application",

        Doc1: "Formulaire",
        Doc2: "Pièce d'identité",
        Doc3: "Preuve de revenu",
        otherDoc: "Autre document",
        awaitingFile: "En attende de document",
        Missing: "Manquant",
        docType: "Type de fichier",
        visitInfo: "Info visite",

        //event name
        newProspect: "Nouveau prospect",        
        visitAfter: "Une visite a eu lieu",
        rentedReady: "Prêt à louer",
        unitNotAvailable: "Unité non disponible",
        replaceUnit: "Assigner une unité",
        rentalDate: "Date de location",
        price: "Prix",
        /* From public website */
        fiche : {
          /* building */
          step1Title: "Formulaire de location",
          title: "Demande de location",
          IdImmeuble : "Identification de l'Immeuble",
          nomImeuble: "Nom de l'immeuble",
          adresseImmeuble: "Adresse de l'immeuble",
          appartement: "Appartement",
          loyer: "Loyer",
          period: "Période",
          from: "Du",
          to: "au",
          rooms: "Nb de pièces",
          inclusions: "Inclusions",
          otherServices: "Autres Services",
          promotions: "Promotions",
          /* candidat */
          Idprospect: "Identification du candidat",
          fname: "Prénom",
          lname: "Nom de famille",
          email: "Courriel",
          cell: "Cell",
          phone: "Téléphone",
          birthdate: "Date de naissance",
          chooseAddress: "Trouver votre adresse",
          addressCandidate: "Adresse actuelle",
          civic: "Numéro civique",
          street: "Rue",
          locality: "Ville",
          app: "App #",
          province: "Province",
          country: "Pays",
          postal: "Code postal",
          civilStatus: [{value: null, text: "État civil"}, {value: 1, text: "Célibataire"}, {value: 2, text: "Marrié"},
          {value: 3, text: "Conjoint de fait"}, {value: 4, text: "Veuf"} , {value: 5, text: "Divorcé"} , {value: 6, text: "Séparé"} ],
          childPossession: "Enfant(s)",
          yes: "Oui",
          no: "Non",
          age: "Âge",
          experienceCogir: "Expérience(s) de location avec Cogir",
          experienceQuestion : "Avez-vous déjà habité dans un immeuble géré par Cogir ?",
          completeAddress: "Adresse complète",
          buildingName: "Nom de la propriété",
          rentedMonth: "Loyer/mois",
          startDate: "Date de début",
          endDate: "Date de fin",
          duration: "Durée",
          contactName: "Nom du Propriétaire/Concierge",
          contactPhone: "Téléphone",
          /*Job information */
          jobInformation: "Job information",
          currentSituations: [{value: null, text: "Situation actuelle"}, {value: 1, text: "En emploi"}, {value: 2, text: "Assurance emploi"},
          {value: 3, text: "Aide sociale"}, {value: 4, text: "CNESST"} , {value: 5, text: "Revenu de retraite"} , {value: 6, text: "Autre"} ],
          otherSituation: "Autre situation",
          emplInsurance: "Assurance emploi",
          welfare: "Aide sociale",
          CNESST: "CNESST",
          retIncome: "Revenu de retraite",
          otherIncome: "Autre revenu",
          employerName: "Nom de l'employeur/ville",
          rhDirector: "Directeur R.H",
          employerPhone: "Téléphone employeur",
          position: "Poste occupé",
          annualSalary: "Salaire annuel",
          otherAmount: "Montant",
          totalIncome: "Revenus totaux",
          student: "Étudiant",
          studentQuestion: "Êtes-vous étudiant ?",
          school: "École/Université",
          pretBourse: "Prêt/Bourse",
          banque: "Banque",
          bankName: "Nom de la banque",
          bankAddress: "Adresse de la succursale bancaire",
          personalRef: "Références personnelles",
          refName: "Nom complet",
          refAddress: "Adresse complète",
          refCity: "Ville",
          refCell: "Cell",
          refPhone: "Téléphone",
          consent: "Consentement",
          endorserForm: "Formulaire de l'endosseur",
          endorserSignature: "Signature de l'endosseur",
          prp: "*** Veuillez noter que notre Société est assujettie et respecte la Loi sur la protection des renseignements personnels et les documents électroniques (LPRPSP).",
          declaration: "Je, soussigné, déclare que les renseignements fournis sont véridiques et j’autorise tout agent de renseignements personnels, bureau de crédit, mon employeur, mon "+
          "propriétaire actuel et/ou précédent et ma banque à confirmer et à divulguer des renseignements personnels me concernant au locateur, à son représentant et/ou à son "+
          "mandataire afin d’évaluer la présente offre de location ou pour tout amendement, renouvellement ou prolongation de ladite location. Il est clairement entendu que les "+
          "informations inscrites sur le présent document et celles obtenues par le locateur, son représentant et/ou son mandataire sont confidentielles. De plus, je m’engage à signer "+
          "un bail pour ledit logement à condition que cette demande soit acceptée dans les 10 jours. ",
          optIn: "Par la présente, je consens à recevoir tout avis, correspondance, "+
          "procédure ou tout autre document du locateur pour valoir notification et/ou signification à mon adresse courriel.",
       
        }
      },
      action: {
        GroupMemberManagement: "Gestion des membres",
        setRecurrence: "Répéter cette tâche",
        dayOfWeek: "Jour de la semaine",
        specificDate: "Date spécifique",
        chooseFrequency: "Choisir la fréquence",
        chooseInterval: "Choisir l'interval",
        chooseWeekIndex: "Choosir l'index de la semaine",
        viewTaskRecurrenceList: "Voir la liste",

        chooseGroupingName: "Choisir un nom pour le regroupement",
        managePlannerGrouping: "Ajouter un nouveau regroupement",
        editPlannerGrouping: "Modification d'un regroupement",
        followThatLink: "Suivre ce lien",
        chooseReportType: "Choisir le type de rapport",
        chooseFirstDate: "Choisir la première date",
        chooseSecondDate: "Choisir la deuxième date",
        addBudgetBuildingData: "Ajouter les données budgétaires pour cet immeuble",
        removeAllData: "Supprimer tout",
        removeAnnualBudgetData: "Êtes-vous certain de vouloir supprimer les données budgétaires pour cette année ?",
        addBudgetDataForThisYear: "Ajouter les données budgétaires pour cette année",
        getMemberOf: "Voir les membres du groupe",
        removeKey: "Êtes-vous certain de vouloir supprimer cette clé ?",
        restoreKey: "Êtes-vous certain de vouloir restaurer cette clé ?",
        restore: "Restaurer",
        addFieldName: "Ajouter un champ",
        addANewKey: "Ajouter une nouvelle clé",
        currentUserList: "Liste des assignations",
        updateIndividualTask: "Mettre à jour la tâche pour un immeuble",
        chooseGroup: "Choisir un groupe",
        addAssociation: "Ajouter une association",
        chooseMemberOfTeam: "Choisir un membre de l'équipe",
        chooseMembers: "Choisir des membres",
        viewMembers: "Voir les membres",
        step1: "Choisir une tâche",
        step2: "Assigner une tâche",
        addUserTeamGroup: "Ajouter des utilisateurs à un groupe Team",
        removeUserTeamGroup: "Retirer des utilisateurs d'un groupe Team",
        addNewTask: "Ajouter une nouvelle tâche",
        selectAll: "Tout sélectionner",
        selectAllBuilding: "Sélectionner tous les groupe d'immeuble",
        selectAllUser: "Sélectionner tous les groupes d'utilisateurs",
        assignTask: "Assigner une tâche",
        resetTheList: "Réinitialiser la liste",
        chooseUser: "Entrez le nom d'un utilisateur",
        chooseBucket: "Choisir un bucket",
        chooseLabel: "Choisir des étiquettes",
        update: "Mettre à jour",
        updateTaskEvent: "Mettre à jour la tâche pour tous les immeubles",
        removeTaskEvent: "Supprimer la tâche pour tous les immeubles",
        useGenericEmail: "Cliquer sur ce lien pour utiliser le courriel générique (123@noemail.com)",
        clickLink: "Cliquer sur ce lien",
        addImage: "Ajouter des images",
        confirmedPrice: "Confirmer le prix des unités",
        SubmitUnitsCheck: "Soumettre {0} unité(s)",
        confirmednewstatus: "Confirmer le nouveau statut",
        notinterested: "Pas intéressé",
        receiptDate: "Date de réception",
        decisionDate: "Date de la décision",
        chooseStatus: "Choisir le statut",
        drop: "Déplacer les items à supprimer ici",
        byDay: "Par jour",
        byMonth: "Par mois",
        byWeek: "Par semaine",
        byYear: "Par année",
        customRepeat: "Personalisé",
        byrange: "Par intervalle de date",
        cancelMeeting: "Annuler l'évènement dans le calendrier",
        newApplication : "Nouvelle application",
        addRating: "Ajout",
        addCommunication: "Ajouter une communication",
        addVisit: "Ajouter une visite",
        addUnitVisit: "Ajouter une unité pour une visite",
        addApplication: "Ajouter une application",
        generateReport: "Générer un rapport",
        generateExcel: "Générer un rapport Excel",
        validate: "Valider",
        addBuildingForUser: "Choisir des immeubles",
        editBuildingForUser: "Modifier les propriétés d'un utilisateur",
        removeAllActiveSession: "Annuler toutes les sessions actives",
        transfertAllSession: "Transférer toutes les sessions à un autre utilisateur",
        gotoprospect: "Voir la liste des prospects",
        login: "S'identifier",
        logout: "Déconnexion",
        add: "Ajout",
        addUser: "Ajouter un utilisateur",
        addYear: "Ajouter une année",
        clearField: "Vider les champs",
        show: "Ouvrir",
        hide: "Fermer",
        addProspect: "Ajouter un candidat",
        chooseReason: "Choisir une raison",
        choose: "Choisir",
        chooseDate: "Choisir une date",
        changeRentalDate: "Changer la date de location",
        chooseStartDate: "Choisir la date de début",
        chooseEndDate: "Choisir la date de fin",
        chooseName: "Choisir un nom pour l'affichage",
        comDate: "Date de la communication",
        selected: "Choisie",
        report: "Obtenir un rapport",
        search:"Chercher",
        searchprospects: "Chercher un prospect",
        returntohomepage: "Retour à l'accueil",
        return: "Retour",
        returnToUM: "Retour à la gestion des utilisateurs",
        submit: "Soumettre",
        copy: "Copier",
        addstatus: "Ajouter un statut",
        addevent: "Ajouter un incident",
        unitNotReady: "Cette unité n'est pas disponible",
        setUnitNotReady: "Marquer cette unité non disponible",
        unitReady: "Cette unité est disponible",
        setUnitReady: "Marquer cette unité disponible",
        setUnitStatus : "Ajouter un statut à l'unité",
        choosefile: "Choisir un fichier",
        suivi: "Suivi",
        infobuilding: "Information sur l'unité",
        change: "Change",
        confirmed: "Confirmer",
        confirmedMr: "Cocher pour confirmer l'envoi",
        addfollowup: "Ajouter un suivi",
        rentedCheckbox: "Le prospect <strong> {0} </strong> a loué l'appartement {1}",
        edit: "Modifier le prospect",
        editUser: "Modifier l'utilisateur",
        editBudget: "Modifier le budget",
        editBuilding: "Modifier une propriété",
        addBuilding: "Ajouter une propriété",
        addClient: "Ajouter un client",
        addUnits: "Remplacer l'unité",
        delete: "Supprimer",
        remove: "Enlever",
        rmve: "Êtes-vous certain de vouloir retirer",
        cncl: "Annuler",
        send: "Envoyer",
        prospectForUnit: "Voir la table des prospects pour cette unité",
        confirmedClosedEvent: "Unité prête pour la location",
        teamMeeting: "Rencontre Team",
        applicationStatus: "Choisir un nouveau statut",
        creditCondition: "Choisir un motif",
        applicationDocType: "Choisir le type de document",
        missingDoc: "Ajouter un document manquant",
        endorser: "Ajouter un endosseur",
        changeStatus: "Statut",
        credit: "Crédit",
        cancelCurrent: "Annuler la requête",
        confirmedCancellation: "Cliquer sur le bouton de confirmation pour annuler",
        confirmedContact: "Cliquer pour confirmer l'envoi d'une communication",
        justwait: "En attente du crédit",
        historic: "Historique",
        history: "Historique des suivis",
        reset: "Effacer les filtres",
        editReference: "Modification des références",
        editCreditCondition: "Modification des conditions",
        reload: "Recharger",
        addNewRentalDate: "Changer la date de location"
      },
      info: {
        plannerGroupingMaxLength: "L'assignation de groupe est limitée à 25 groupes",
        plannerGroupMaxLength: "L'assignation de tâche est limitée à 25 groupes",
        noTaskForThisPeriod: "Aucune tâche pour cette période",
        openTaskNoTFound: "Les tâches ouvertes suivantes non pas été trouvées",
        taskNotFound: "La tâche n'a pas été trouvé dans les groupes suivants :",
        inactiveKey: "Cette clé est inactive. Veuillez la réactiver pour la modifer.",
        chooseAtLeastOneMember: "Vous devez choisir au moins un membre",
        groupSelectForTaskAssignment: "Liste des groupes",
        description: "Entrez des informations sur la tâche",
        chooseMultiple: "Utilisez ctrl clique pour choisir plusieurs éléments",
        taskPriority: [{ value: null, text: "Choisir un niveau" }, { value: 9, text: "low" }, { value: 5, text: "medium" }, { value: 3, text: "important" }, { value: 1, text: "urgent" }],
        groupAlreadyExist: "Cet immeuble est déjà associé à ce groupe : ",
        taskOpen: "Cette tâche est ouverte pour un groupe",
        unauthorized: "Vous n'êtes pas autorisé à accéder à cette application",
        tooManyUser: "Trop d'utilisateur pour le groupe. Max. 20",
        currentTeamMember: "Membre du groupe Team",
        currentOwner: "Propriétaire du groupe",
        errorNoUserSelected: "Vous devez choisir au moins 2 utilisateurs",
        choice: "Les choix apparaîtront ici",
        buildingForUser: "Associé des immeubles à un utilisateur",
        warningsamename: "Un groupe avec le même nom existe pour cet immeuble",
        errornoowner: "Un nouveau groupe doit avoir au minimum un dr ou un admin et un utilisateur",
        existingTeamForBuilding: "Ce groupe est déjà associé à un immeuble",
        excelFilesNotExist: "Vous devez créer un fichier {0} à la racine de votre compte Cogir Microsoft OneDrive.",
        approbationRequest: "Choisir si l'application est approuvée ou refusée pour <strong>{0}</strong>.",
        publicProspectApplication: "Confirmer que la demande d'application pour <strong>{0}</strong> est conforme.",
        requiredOne: "Au moins un fichier est obligatoire",
        acknowledgeNewUnit: "Confirmer le changement d'unité",
        drApprobation: "En attente de l'approbation du DR",
        successcanceled: "Visite annulée avec succès",
        userAddedSuccess: "Utilisateur ajouté avec succès",
        userRemovedSuccess: "Utilisateur supprimé avec succès",
        successnoshow: "Le statut du prospect a été mis à jour",
        partOfDay: "Moment de la journée de la prise de contact",
        showNoshow: "Prospect présent ou non pour une visite",
        meetingConflict: "Il y a déjà un ou des évènements à votre calendrier pour cette plage horaire : ",
        goAnyway: "Appuyez sur soumettre pour poursuivre malgré l'avertissement.",
        reportsLength: "Aucune données pour cette requête.",
        meetingNotFound: "Cette visite n'a pas été trouvée",
        meetingCancel: "Cette visite a été annulée",
        notCogirUser: "Cette adresse courriel ne fait pas partie du domaine cogir.net",
        activesessions: "Il y a des sessions actives pour cette propriété",
        response: "Statut de la réponse",
        successgeneric: "Vos informations ont été soumises avec succès",
        successExcel: "Vos informations ont été soumises avec succès. Suivez le lien pour obtenir votre rapport Excel.",
        successmeetingrequest: "Votre invitation a bien été envoyée",
        nomeetingrequest: "Une erreur s'est produite lors de l'envois de l'invitation",
        errorfields: "Tous les champs du tableau sont requis et doivent être numérique",
        errorgenericarg: "Une erreur s'est produite : {0}",
        errorgeneric: "Une erreur s'est produite",
        errorlogin: "Essayer de vous connecter en appuyant sur le bouton de connection",
        emailexist: "Ce courriel appartient à un candidat actif.",
        emailexistuser: "Ce courriel appartient à un utilisateur actif.",
        months : 'Janvier_Février_Mars_Avril_Mai_Juin_Juillet_Août_Septembre_Octobre_Novembre_Décembre',
        required: "Ce champs est requis",
        email: "Cette adresse courriel n'est pas valide",
        emailattendees: "Add email address separated by comma",
        tel: "Un numéro de téléphone doit seulement contenir des nombres",
        integer: "Ce champs doit contenir des nombres",
        maxLength: "Ce champ est limité à {0} charactères",
        minLength: "Ce champ doit contenir {0} charactères au minimum",
        units: "Vous devez choisir une ou plusieurs unités",
        errorfile: "Le fichier téléversé n'est pas valide",
        textConfirmed: "Appuyez sur le bouton ci-dessous pour confirmer que le prospect <br> <strong> {0} </strong> <br> a loué l'appartement {1}",
        removedTaskEvent: "Appuyez sur le bouton ci-dessous pour confirmer que la tâche <br> <strong> {0} </strong> sera fermée",
        removeConfirmed: "Appuyez sur le bouton ci-dessous pour confirmer que le prospect <br> <strong> {0} </strong> <br> est dissocié de l'appartement {1}",
        removeConfirmedLeads: "Appuyez sur le bouton ci-dessous pour confirmer que le lead <strong> {0} </strong> n'est plus actif",
        removeConfirmedProspect: "Appuyez sur le bouton ci-dessous pour confirmer que le prospect <strong> {0} </strong> n'est plus actif",
        changeStatusProspect: "Appuyez sur le bouton ci-dessous pour confirmer que le prospect <strong> {0} </strong> n'est pas intéressé",
        removeConfirmedUser: "Appuyez sur le bouton ci-dessous pour confirmer que l'utilisateur <strong> {0} </strong> n'est plus actif",
        removeConfirmedUserBuilding: "Appuyez sur le bouton ci-dessous pour confirmer que l'utilisateur <strong> {0} </strong> n'est plsu associée à la propriété <strong> {1} </strong>",
        removeFromUnitRented: "Appuyez sur le bouton ci-dessous pour confirmer que le prospect <strong> {0} </strong> doit être enlever du tableau des unités louées",
        removeBuilding: "Appuyez sur le bouton ci-dessous pour confirmer que la propriété <strong> {0} </strong> sera enlevée de la liste",
        notoken: "Aucun token",
        myMSALObj: "myMSALObj invalide",
        UserNotAuthorized: "Utilisateur non autorisé",
        MeetingRequestNotSend: "L'invitation n'a pas été envoyée",
        startPast: "L'huere de début est dans le passé.",
        dateBefore: "La date de début doit être avant la date de fin.",
        maxVisitTime: "La durée maximale d'une visite est de 5 heures.",
        comments: "Commentaires ...",
        reason: "Ajouter une explication",
        applicationStatus: "Le nouveau statut de l'application est : {0}",
        documentTypeError: "Vous devez choisir un type de document pour chaque champs",
        updateMissingDoc: "Vous devez soumettre {0} fichier(s)",
        missingDocInProgress: "En attende de document manquant, vous allez recevoir {0} fichier(s).",
        limitNumberOfFiles: "Vous ne pouvez pas téléverser plus de 3 fichier(s)",
        limitNumberOfFilesMissingDoc: "Vous ne pouvez pas téléverser plus fichiers que de documents manquants",  
        invalidFileType: "Type de fichier non supporté (.pdf, .jpg ou .png) ou fichier trop volumineux (max 4 mb)",
        requiredDoc: "Types de fichier supportés (.pdf, .jpg or .png)",
        invalidFileSize: "Votre image est trop volumineuse (max 4 mb)",
        invalidFileTypeCsv: "Type de fichier non supporté (csv)",
        invalidFileTypeFormat: "Le format du fichier est invalide",
        startLocation : "Inscrire la date du début de location",
        confirmationLocation: "Confirmer la date de location",
        emptyApplication : "Aucune application en ce moment",
        emptyProspect: "Aucun prospect pour cet immeuble",
        emptyVacant: "Aucune unité pour cet immeuble",
        emptyNotification: "Aucune notification en ce moment",
        emptyField: "Tous les champs doivent être remplis",
        infoevent: "Permet de marquer une unité disponible ou non disponible à la location",
        buildingExist: "Cet immeuble est déjà présent dans la base de données",
        nobuilding: "Il n'y a aucune propriété avec ce NOCIE et ce NODIV",
        noendorserpossible : "Tous les applicants ont un endosseur pour cette application",
        invalidDate: "Vous devez choisir un mois valide"
      }
    }
  }
})
